import React, { useState, useRef } from 'react';

// sneak peak images
import thyriod from '../assets/images/ii-1.png';
import liverFunction from '../assets/images/ii-6.png';
import kidneyFunction from '../assets/images/ii-7.png';
import urineRE from '../assets/images/urinalysis.png';
import vitaminB12 from '../assets/images/Awad-vitaminB.png';
import vitaminD from '../assets/images/Awa-vitaminD.jfif';
import amylase from '../assets/images/Awa-amalase.png';
import glucoseR from '../assets/images/glucose-blood.png';
import hbA1c from '../assets/images/HbA1c.png';
import lipidScreen from '../assets/images/lipid.png';
import hscrp from '../assets/images/ii-2.png';
import apoAB from '../assets/images/Apo A&B.jpg';
import hemogramCBC from '../assets/images/ii-3.png';
import ironStudies from '../assets/images/iron.png';
import anatomy from '../assets/images/anatomy-1.png';
import anatomyFemale from '../assets/images/anatomy-female.png';
// import anabrain from '../assets/images/ana-brain.png';
import analungs from '../assets/images/ana-lungs.png';
import anaheart from '../assets/images/ana-heart.png';
import analiver from '../assets/images/ana-liver.png';
import anastomuch from '../assets/images/ana-stomuch.png';
import anakidneysleft from '../assets/images/ana-kidneys-left.png';
import anakidneysright from '../assets/images/ana-kidneys-right.png';
import analargeintestine from '../assets/images/ana-largeintestine.png';
import anasamllintestine from '../assets/images/ana-samllintestine.png';
import anabones from '../assets/images/ana-left-leg.png';
import anabonesRight from '../assets/images/ana-right-leg.png';
import anathyriod from '../assets/images/ana-thyriod.png';



const SneakPeak = ({ data }) => {

    const [hoverImageSrc, setHoverImageSrc] = useState('');
    const [isHovering, setIsHovering] = useState(false);
    const [hoverOrgan, setHoverOrgan] = useState(null); // New state to store organ data
    const hoverImageRef = useRef(null);
    const anatomyWrapperRef = useRef(null);

    // Create a context that includes all the images in the assets/images folder
    const imagesContext = require.context('../assets/images', false, /\.(png|jpe?g|gif)$/);

    const organsData = [
        {
            title: "Thyroid",
            description: "TFT's consist of a group of blood tests that determine the working of the thyroid gland by measuring the thyroid hormone levels."
        },
        {
            title: "Lungs",
            description: ""
        },
        {
            title: "Lipid Profile",
            description: "A lipid profile, also known as a cholesterol test, is prescribed to determine the risk of cardiovascular diseases."
        },
        {
            title: "Liver Function test",
            description: "LFTs are blood tests that monitor liver proteins, enzymes, and substances. They help assess liver function, detect damage, and diagnose conditions like hepatitis."
        },
        {
            title: "Stomach",
            description: ""
        },
        {
            title: "Kidneys",
            description: "Kidney Function Test helps to evaluate the proper functioning of the kidneys."
        },
        {
            title: "Large Intestine",
            description: ""
        },
        {
            title: "Small Intestine",
            description: ""
        },
        {
            title: "Vitamin D",
            description: "Vitamin D regulates calcium and phosphate levels for healthy bones, teeth, and muscles. Sunlight exposure, fortified foods, and supplements help fulfil Vitamin D needs and prevent deficiency."
        }
    ];

    // Map image filenames to organs
    const organImageMap = {
        "ana-thyriod.png": organsData[0],
        "ana-lungs.png": organsData[1],
        "ana-heart.png": organsData[2],
        "ana-liver.png": organsData[3],
        "ana-stomuch.png": organsData[4],
        "ana-kidneys-left.png": organsData[5],
        "ana-kidneys-right.png": organsData[5], // Same organ for both left and right kidneys
        "ana-largeintestine.png": organsData[6],
        "ana-samllintestine.png": organsData[7],
        "ana-left-leg.png": organsData[8],
        "ana-right-leg.png": organsData[8]
    };

    const handleMouseEnter = (event, detailSrc) => {
        // Avoid triggering hover effect for the anatomy wrapper (house)
        if (event.target === anatomyWrapperRef.current) return;
        //const imagePath = require(`../assets/images/${detailSrc}`);
        const imagePath = imagesContext(`./${detailSrc}`);
        setHoverImageSrc(imagePath);
        setIsHovering(true);

        // Set hover organ data based on the image
        const organ = organImageMap[detailSrc];
        setHoverOrgan(organ);

        positionHoverImage(event);
    };

    const handleMouseMove = (event) => {
        if (isHovering) {
            positionHoverImage(event);
        }
    };

    const handleMouseLeave = () => {
        setIsHovering(false);
        setHoverOrgan(null); // Reset organ data when mouse leaves
    };

    const positionHoverImage = (event) => {
        // Ensure hoverImageRef.current exists before accessing its properties
        if (!hoverImageRef.current) return;

        const imageWidth = hoverImageRef.current.offsetWidth;
        const imageHeight = hoverImageRef.current.offsetHeight;

        const rect = anatomyWrapperRef.current.getBoundingClientRect();
        const mouseX = event.clientX - rect.left;
        const mouseY = event.clientY - rect.top;

        let left = mouseX + 10;
        let top = mouseY + 10;

        if (left + imageWidth > rect.width) {
            left = mouseX - imageWidth - 10;
        }
        if (top + imageHeight > rect.height) {
            top = mouseY - imageHeight - 10;
        }

        hoverImageRef.current.style.left = `${left}px`;
        hoverImageRef.current.style.top = `${top}px`;
    };

    let thyrioddisplayed = false;
    let liverDisplayed = false;
    let kidneyDisplay = false;
    let urineDisplay = false;
    let vitaminBDisplay = false;
    let vitaminDDisplay = false;
    let amylaseDisplay = false;
    let glucoseRDisplay = false;
    let hbA1cDisplay = false;
    let lipidDisplay = false;
    let hscrpDisplay = false;
    let apoDisplay = false;
    let hemogramDisplay = false;
    let ironDisplay = false;
    const profile = data?.data?.patientDetails || [];
    const reportListData = (data?.data?.smartReportListDetails || []);

    // const thyriodData = reportListData.filter((item) => item.PanelCode === "Z318PF" || item.PanelCode === "Z318").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);
   // const thyriodData = reportListData.filter((item) => item.PanelCode === "Z284PF" || item.PanelCode === "Z284").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);
   const thyriodData = reportListData.filter((item) => item.TestOrder === "11" || item.TestOrder === "10.8" || item.TestOrder === "10.9").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

   // const liverData = reportListData.filter((item) => item.StandardPanelCode === "Z005").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);
    const liverData = reportListData.filter((item) => item.StandardPanelCode === "Z005" || item.TestOrder === "8.8" || item.TestOrder === "8.9").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    // const liverData = reportListData.filter
    //const kidneyData = reportListData.filter((item) => item.StandardPanelCode === "Z007").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    const kidneyData = reportListData.filter((item) => item.StandardPanelCode === "Z007").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

   // const urineData = reportListData.filter((item) => item.PanelCode === "U001PF" || item.PanelCode === "U001").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    const urineData = reportListData.filter((item) => item.TestOrder === "10").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

   // const vitaminBData = reportListData.filter((item) => item.PanelCode === "R047PF" || item.PanelCode === "R047").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    const vitaminBData = reportListData.filter((item) => item.TestOrder === "12").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    //const vitaminDData = reportListData.filter((item) => item.PanelCode === "R119PF" || item.PanelCode === "R119").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    const vitaminDData = reportListData.filter((item) => item.TestOrder === "13").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

   // const amylaseData = reportListData.filter((item) => item.PanelCode === "B050PF" || item.PanelCode === "B050").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    const amylaseData = reportListData.filter((item) => item.TestOrder === "14").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

   // const glucoseRData = reportListData.filter((item) => item.PanelCode === "B001PF" || item.PanelCode === "B001").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    const glucoseRData = reportListData.filter((item) => item.TestOrder === "4").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

   // const hbA1cData = reportListData.filter((item) => item.PanelCode === "B080PF" || item.PanelCode === "B080").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    const hbA1cData = reportListData.filter((item) => item.TestOrder === "5").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

   // const lipidData = reportListData.filter((item) => item.PanelCode === "Z318PF" || item.PanelCode === "Z318").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    const lipidData = reportListData.filter((item) => item.TestOrder === "6" || item.TestOrder === "6.1" || item.TestOrder === "6.2").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    //const hscrpData = reportListData.filter((item) => item.PanelCode === "B134PF" || item.PanelCode === "B134").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    const hscrpData = reportListData.filter((item) => item.TestOrder === "7" || item.AnalyteCode === "38839").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    //const apoData = reportListData.filter((item) => item.PanelCode === "Z212PF" || item.PanelCode === "Z212").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    const apoData = reportListData.filter((item) => item.TestOrder === "8" || item.AnalyteCode === "30284" || item.AnalyteCode === "30285" || item.AnalyteCode === "37700" || item.AnalyteCode === "38727" || item.AnalyteCode === "38728" || item.AnalyteCode === "38787" || item.AnalyteCode === "38788" ).sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

   // const hemogramData = reportListData.filter((item) => item.PanelCode === "Z019PF" || item.PanelCode === "Z019" || item.PanelCode ==="Z021PF" || item.PanelCode ==="Z021").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    const hemogramData = reportListData.filter((item) => item.TestOrder === "1").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

  //  const ironData = reportListData.filter((item) => item.PanelCode === "H020PF" || item.PanelCode === "H020").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    const ironData = reportListData.filter((item) => item.TestOrder === "3" || item.TestOrder === "3.1").sort((a, b) => a.AnalyteOrder - b.AnalyteOrder);

    return (
        <>
            <div className="container-1  page-padding">
                <div className="col-12 text-center">
                    <span className="inside-body-title">Report - Overview</span>
                </div>
                <div className="inside-body-wrapper">

                    <div className="anatomy-part-wrapper">
                        <div className="part-wrapper">
                            <div className="img-wrapper">
                                <img className="img-fluid" src={thyriod} />
                            </div>
                            <div className="text-wrapper">
                                <h4 className="test-name">Thyroid</h4>
                                {thyriodData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted.</div>
                                ) : (
                                    thyriodData.some(item => item.IsBold === 'Yes') ? (
                                        thyriodData.map((item, index) => {
                                            if (item.IsBold === 'Yes' && !thyrioddisplayed) {
                                                thyrioddisplayed = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }

                                            return null;
                                        })
                                    ) : (
                                        thyriodData.map((item, index) => {
                                            if (item.IsBold === 'No' && !thyrioddisplayed) {
                                                thyrioddisplayed = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}

                            </div>

                        </div>
                        <div className="part-wrapper">
                            <div className="img-wrapper">
                                <img className="img-fluid" src={liverFunction} />
                            </div>
                            <div className="text-wrapper">
                                <h4 className="test-name">Liver Function</h4>
                                {liverData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted. </div>
                                ) : (
                                    liverData.some(item => item.IsBold === 'Yes') ? (

                                        liverData.map((item, index) => {
                                            if (item.IsBold === 'Yes' && !liverDisplayed) {
                                                liverDisplayed = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }

                                            return null;
                                        })
                                    ) : (
                                        liverData.map((item, index) => {
                                            if (item.IsBold === 'No' && !liverDisplayed) {
                                                liverDisplayed = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}
                            </div>

                        </div>
                        <div className="part-wrapper">
                            <div className="img-wrapper">
                                <img className="img-fluid" src={kidneyFunction} />
                            </div>
                            <div className="text-wrapper">
                                <h4 className="test-name">Kidney Function</h4>
                                {kidneyData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted.</div>
                                ) : (
                                    kidneyData.some(item => item.IsBold === 'Yes') ? (
                                        kidneyData.map((item, index) => {
                                            if (item.IsBold === 'Yes' && !kidneyDisplay) {
                                                kidneyDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }

                                            return null;
                                        })
                                    ) : (
                                        kidneyData.map((item, index) => {
                                            if (item.IsBold === 'No' && !kidneyDisplay) {
                                                kidneyDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}
                            </div>

                        </div>
                        <div className="part-wrapper">
                            <div className="img-wrapper">
                                <img className="img-fluid" src={urineRE} />
                            </div>
                            <div className="text-wrapper">
                                <h4 className="test-name">Urine R/E</h4>
                                {urineData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted.</div>
                                ) : (
                                    urineData.some(item => item.IsBold === 'Yes') ? (
                                        urineData.map((item, index) => {
                                            if (item.IsBold === 'Yes' && !urineDisplay) {
                                                urineDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }

                                            return null;
                                        })
                                    ) : (
                                        urineData.map((item, index) => {
                                            if (item.IsBold === 'No' && !urineDisplay) {
                                                urineDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}
                            </div>

                        </div>
                        <div className="part-wrapper">
                            <div className="img-wrapper">
                                <img className="img-fluid" src={vitaminB12} />
                            </div>
                            <div className="text-wrapper">
                                <h4 className="test-name">Vitamin B12</h4>
                                {vitaminBData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted.</div>
                                ) : (
                                    vitaminBData.some(item => item.IsBold === 'Yes') ? (
                                        vitaminBData.map((item, index) => {
                                            if (item.IsBold === 'Yes' && !vitaminBDisplay) {
                                                vitaminBDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }

                                            return null;
                                        })
                                    ) : (
                                        vitaminBData.map((item, index) => {
                                            if (item.IsBold === 'No' && !vitaminBDisplay) {
                                                vitaminBDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}
                            </div>

                        </div>
                        <div className="part-wrapper">
                            <div className="img-wrapper">
                                <img className="img-fluid" src={vitaminD} />
                            </div>
                            <div className="text-wrapper">
                                <h4 className="test-name">Vitamin D</h4>
                                {vitaminDData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted.</div>
                                ) : (
                                    vitaminDData.some(item => item.IsBold === 'Yes') ? (
                                        vitaminDData.map((item, index) => {
                                            if (item.IsBold === 'Yes' && !vitaminDDisplay) {
                                                vitaminDDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }

                                            return null;
                                        })
                                    ) : (
                                        vitaminDData.map((item, index) => {
                                            if (item.IsBold === 'No' && !vitaminDDisplay) {
                                                vitaminDDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}
                            </div>

                        </div>
                        <div className="part-wrapper">
                            <div className="img-wrapper">
                                <img className="img-fluid" src={amylase} />
                            </div>
                            <div className="text-wrapper">
                                <h4 className="test-name">Amylase Serum</h4>
                                {amylaseData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted.</div>
                                ) : (
                                    amylaseData.some(item => item.IsBold === 'Yes') ? (
                                        amylaseData.map((item, index) => {
                                            if (item.IsBold === 'Yes' && !amylaseDisplay) {
                                                amylaseDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }

                                            return null;
                                        })
                                    ) : (
                                        amylaseData.map((item, index) => {
                                            if (item.IsBold === 'No' && !amylaseDisplay) {
                                                amylaseDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}
                            </div>

                        </div>
                    </div>

                    {/* =========for common image======= */}

                    <div className="anatomy-wrapper" ref={anatomyWrapperRef}>
                        <img className="large-image" src={anatomy} alt='Anatomy' />

                        <img className="thyriod-img small-image" src={anathyriod} data-detail="ana-thyriod.png"
                            onMouseEnter={(e) => handleMouseEnter(e, 'ana-thyriod.png')}
                            onMouseMove={handleMouseMove}
                            onMouseLeave={handleMouseLeave} />
                        <img className="lungs-img small-image" src={analungs} data-detail="ana-lungs.png"
                            onMouseEnter={(e) => handleMouseEnter(e, 'ana-lungs.png')}
                            onMouseMove={handleMouseMove}
                            onMouseLeave={handleMouseLeave} />
                        <img className="heart-img small-image" src={anaheart} data-detail="ana-heart.png"
                            onMouseEnter={(e) => handleMouseEnter(e, 'ana-heart.png')}
                            onMouseMove={handleMouseMove}
                            onMouseLeave={handleMouseLeave} />
                        <img className="liver-img small-image" src={analiver} data-detail="ana-liver.png"
                            onMouseEnter={(e) => handleMouseEnter(e, 'ana-liver.png')}
                            onMouseMove={handleMouseMove}
                            onMouseLeave={handleMouseLeave} />
                        <img className="stomuch-img small-image" src={anastomuch} data-detail="ana-stomuch.png"
                            onMouseEnter={(e) => handleMouseEnter(e, 'ana-stomuch.png')}
                            onMouseMove={handleMouseMove}
                            onMouseLeave={handleMouseLeave} />
                        <img className="kidneys-left-img small-image" src={anakidneysleft} data-detail="ana-kidneys-left.png"
                            onMouseEnter={(e) => handleMouseEnter(e, 'ana-kidneys-left.png')}
                            onMouseMove={handleMouseMove}
                            onMouseLeave={handleMouseLeave} />
                        <img className="kidneys-right-img small-image" src={anakidneysright} data-detail="ana-kidneys-right.png"
                            onMouseEnter={(e) => handleMouseEnter(e, 'ana-kidneys-right.png')}
                            onMouseMove={handleMouseMove}
                            onMouseLeave={handleMouseLeave} />
                        <img className="largeintestine-img small-image" src={analargeintestine} data-detail="ana-largeintestine.png"
                            onMouseEnter={(e) => handleMouseEnter(e, 'ana-largeintestine.png')}
                            onMouseMove={handleMouseMove}
                            onMouseLeave={handleMouseLeave} />
                        <img className="samllintestine-img small-image" src={anasamllintestine} data-detail="ana-samllintestine.png"
                            onMouseEnter={(e) => handleMouseEnter(e, 'ana-samllintestine.png')}
                            onMouseMove={handleMouseMove}
                            onMouseLeave={handleMouseLeave} />

                        <img className="bones-left-img small-image" src={anabones} data-detail="ana-left-leg.png"
                            onMouseEnter={(e) => handleMouseEnter(e, 'ana-left-leg.png')}
                            onMouseMove={handleMouseMove}
                            onMouseLeave={handleMouseLeave} />

                        <img className="bones-right-img small-image" src={anabonesRight} data-detail="ana-right-leg.png"
                            onMouseEnter={(e) => handleMouseEnter(e, 'ana-right-leg.png')}
                            onMouseMove={handleMouseMove}
                            onMouseLeave={handleMouseLeave} />
                        {/* Hover Image and Table */}
                        {isHovering && hoverOrgan && (
                            <div className="hover-image" id="hover-image" ref={hoverImageRef}>
                                <div style={{ display: 'block' }}>
                                    <img src={hoverImageSrc} alt="Anatomy Detail" />
                                    <br />
                                    <div style={{ Width: 200 + 'px' }}>
                                        <table className="table table-sm table-borderless">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <strong className='mb-3'>{hoverOrgan.title}</strong>
                                                        <br />
                                                        {hoverOrgan.description}
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>

                    


                    <div className="anatomy-part-wrapper  part-2">
                        <div className="part-wrapper">
                            <div className="text-wrapper">
                                <h4 className="test-name">Glucose</h4>
                                {glucoseRData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted.</div>
                                ) : (
                                    glucoseRData.some(item => item.IsBold === 'Yes') ? (
                                        glucoseRData.map((item, index) => {
                                            if (item.IsBold === 'Yes' && !glucoseRDisplay) {
                                                glucoseRDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }

                                            return null;
                                        })
                                    ) : (
                                        glucoseRData.map((item, index) => {
                                            if (item.IsBold === 'No' && !glucoseRDisplay) {
                                                glucoseRDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}
                            </div>
                            <div className="img-wrapper">
                                <img className="img-fluid" src={glucoseR} />
                            </div>
                        </div>
                        <div className="part-wrapper">

                            <div className="text-wrapper">
                                <h4 className="test-name">HbA1c</h4>
                                {hbA1cData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted.</div>
                                ) : (
                                    hbA1cData.some(item => item.IsBold === 'Yes') ? (
                                        hbA1cData.map((item, index) => {
                                            if (item.IsBold === 'Yes' && !hbA1cDisplay) {
                                                hbA1cDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }

                                            return null;
                                        })
                                    ) : (
                                        hbA1cData.map((item, index) => {
                                            if (item.IsBold === 'No' && !hbA1cDisplay) {
                                                hbA1cDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}
                            </div>
                            <div className="img-wrapper">
                                <img className="img-fluid" src={hbA1c} />
                            </div>
                        </div>
                        <div className="part-wrapper">

                            <div className="text-wrapper">
                                <h4 className="test-name">LIPID PROFILE</h4>
                                {lipidData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted.</div>
                                ) : (
                                    lipidData.some(item => item.IsBold === 'Yes') ? (
                                        lipidData.map((item, index) => {
                                            // to exclude apo, hscrp... use analytecode
                                            if (item.IsBold === 'Yes' && !['38839', '30284', '30285', '37700', '38727', '38728', '38787', '38788'].includes(item.AnalyteCode) && !lipidDisplay) {
                                                lipidDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }
                                            return null;
                                        })
                                    ) : (
                                        lipidData.map((item, index) => {
                                            // to exclude apo, hscrp... use analytecode
                                            if (item.IsBold === 'No' && !['38839', '30284', '30285', '37700', '38727', '38728', '38787', '38788'].includes(item.AnalyteCode) && !lipidDisplay) {
                                                lipidDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}
                            </div>
                            <div className="img-wrapper">
                                <img className="img-fluid" src={lipidScreen} />
                            </div>
                        </div>
                        <div className="part-wrapper">

                            <div className="text-wrapper">
                                <h4 className="test-name">Hs CRP</h4>
                                {hscrpData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted.</div>
                                ) : (
                                    hscrpData.some(item => item.IsBold === 'Yes') ? (
                                        hscrpData.map((item, index) => {
                                            if (item.IsBold === 'Yes' && !hscrpDisplay) {
                                                hscrpDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }

                                            return null;
                                        })
                                    ) : (
                                        hscrpData.map((item, index) => {
                                            if (item.IsBold === 'No' && !hscrpDisplay) {
                                                hscrpDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}
                            </div>
                            <div className="img-wrapper">
                                <img className="img-fluid" src={hscrp} />
                            </div>
                        </div>
                        <div className="part-wrapper">

                            <div className="text-wrapper">
                                <h4 className="test-name">Apo A&B</h4>
                                {apoData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted.</div>
                                ) : (
                                    apoData.some(item => item.IsBold === 'Yes') ? (
                                        apoData.map((item, index) => {
                                            if (item.IsBold === 'Yes' && !apoDisplay) {
                                                apoDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }

                                            return null;
                                        })
                                    ) : (
                                        apoData.map((item, index) => {
                                            if (item.IsBold === 'No' && !apoDisplay) {
                                                apoDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}
                            </div>
                            <div className="img-wrapper">
                                <img className="img-fluid" src={apoAB} />
                            </div>
                        </div>

                        <div className="part-wrapper">

                            <div className="text-wrapper">
                                <h4 className="test-name">HEMOGRAM - CBC</h4>
                                {hemogramData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted.</div>
                                ) : (
                                    hemogramData.some(item => item.IsBold === 'Yes') ? (
                                        hemogramData.map((item, index) => {
                                            if (item.IsBold === 'Yes' && !hemogramDisplay) {
                                                hemogramDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }

                                            return null;
                                        })
                                    ) : (
                                        hemogramData.map((item, index) => {
                                            if (item.IsBold === 'No' && !hemogramDisplay) {
                                                hemogramDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}
                            </div>
                            <div className="img-wrapper">
                                <img className="img-fluid" src={hemogramCBC} />
                            </div>
                        </div>
                        <div className="part-wrapper">

                            <div className="text-wrapper">
                                <h4 className="test-name">Iron Studies</h4>
                                {ironData.length === 0 ? (
                                    <div className="test-result mt-1">Test not part of the package opted.</div>
                                ) : (
                                    ironData.some(item => item.IsBold === 'Yes') ? (
                                        ironData.map((item, index) => {
                                            if (item.IsBold === 'Yes' && !ironDisplay) {
                                                ironDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact"><span className="test-concern"></span>Need attention</div>
                                                    </React.Fragment>
                                                );
                                            }

                                            return null;
                                        })
                                    ) : (
                                        ironData.map((item, index) => {
                                            if (item.IsBold === 'No' && !ironDisplay) {
                                                ironDisplay = true;
                                                return (
                                                    <React.Fragment key={index}>
                                                        {/* <div className="test-result mt-1">{item.AnalyteName}: {item.Result} {item.Units}</div> */}
                                                        <div className="test-impact mt-1"><span className="test-good"></span> Within normal limit</div>
                                                    </React.Fragment>
                                                );
                                            }
                                        })

                                    )
                                )}
                            </div>
                            <div className="img-wrapper">
                                <img className="img-fluid" src={ironStudies} />
                            </div>

                        </div>
                    </div>



                </div>
            </div>
        </>
    );
}

export default SneakPeak;
